import React from 'react';
import { useField } from 'formik';
import {NumericFormat} from 'react-number-format';

const PriceInput = ({ name, prefix = '', className, showError = true, ...props }) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div>
      <NumericFormat
        {...props}
        value={field.value || ''}
        onValueChange={({ value }) => {
          helpers.setValue(value); // raw value (unformatted)
        }}
        thousandSeparator={true}
        allowNegative={false}
        prefix={prefix} // e.g. '$', '₹', etc.
        className={`${className} input no-spinner`}
      />
      {showError && meta.touched && meta.error && (
        <p className="text-red-500 text-[11px] mt-1">{meta.error}</p>
      )}
    </div>
  );
};

export { PriceInput };
